import { loadInitialPaging } from './ViewArticlesPaging.js'

export function ViewFullArticle(articleId) {
    window.location.href = '/Services/View-FullArticle?ArticleId=' + articleId;
}

export function EditArticle(articleId) {
    window.location.href = '/Services/Edit-Article?ArticleId=' + articleId;
}

export function ViewMore(categoryId) {
    window.location.href = '/News?categoryId=' + categoryId;
}

//export function CategoryManagement() {
//    window.open('/Services/Category-Management');
//}

export function CategoryFilter(paramCategoryId, paramCategoryName) {
    window.history.replaceState(null, null, '?categoryId=' + paramCategoryId + '&pageNumber=1');
    //window.open('/News?CategoryId=' + paramCategoryId);
    const articlesBaseUrl = window.location.protocol + "//" + window.location.host;
    $.ajax({
        type: "POST",
        url: articlesBaseUrl + "/AlliedPilots/Articles/ViewArticlesByPage",
        data: {
            pageNumber: 1,
            categoryId: paramCategoryId
        },
        success: function (response) {
            $(".category-header").show();
            if (paramCategoryId == 0) {
                $(".category-header").html("Latest Articles from APA Headquarters");
            } else {
                $(".category-header").html(paramCategoryName);
            }
            $(".articles-container").html(response);
            loadInitialPaging(true);
        },
        error: function (data) {
        }
    });
}